import { createSelector } from 'reselect';

export const toastsSelector = (state) => state.toast;
export const toastOpenSelector = createSelector(toastsSelector, (toast) => toast.open);
export const toastPropsSelector = createSelector(toastsSelector, (toast) => toast.toastProps);
